/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPageProjectListItemDto } from '../../models/backend-page-project-list-item-dto';

export interface ListProjectsProjectsGet$Params {
  /**
   * Размер страницы
   */
  limit?: number;

  /**
   * Смещение от начала
   */
  offset?: number;
}

export function listProjectsProjectsGet(
  http: HttpClient,
  rootUrl: string,
  params?: ListProjectsProjectsGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPageProjectListItemDto>> {
  const rb = new RequestBuilder(rootUrl, listProjectsProjectsGet.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPageProjectListItemDto>;
    }),
  );
}

listProjectsProjectsGet.PATH = '/projects';
